import { gql } from '@apollo/client';

/**
 * GraphQL queries are excluded from unit-test coverage by policy.
 */
export const SEARCH_CITY_BY_NAME = gql`
	query searchCitiesByName($cityName: String!) {
		searchCitiesByName(cityName: $cityName) {
			id
			name
		}
	}
`;
